import React from 'react';
import { useAvailableFeatureChecker } from '@/hooks/useAvailableFeatureChecker';
import { FeatureKey } from '@/types/feature';

type Props = {
  featureKey: FeatureKey;
  FallbackComponent?: React.ReactNode;
  children: React.ReactNode;
};

// 今後いろんな判断をするようにするかも、今は一旦 featureKey だけ
export const CanAccess = ({
  featureKey,
  FallbackComponent = null,
  children,
}: Props) => {
  const { isLoading, isAvailable } = useAvailableFeatureChecker(featureKey);

  if (isLoading) return null;

  if (!isAvailable) return FallbackComponent;

  return children;
};
